import React, { useState } from 'react'
import { Form, Row, Col,Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { setColorHx, initialState } from '../../store/modules/colorplate';
import langList from '../../utils/languagelist.json'

export default function Colorsmbg() {
  const {...colorValue}=useSelector((state)=>state.colorplate);
  const {lg}=useSelector((state)=>state.language);
  const dispatch=useDispatch();
  const [selectedColor, setSelectedColor] = useState(colorValue.hx);
  const [checkValue, setCheckValue] = useState(false);

  const handleClick = () => {
    colorValue['hx'] = selectedColor;
    dispatch(setColorHx(colorValue))
    localStorage.setItem('color', JSON.stringify(colorValue));
  }

  const handleChang = (index,value) => {
    if(checkValue) return;
    const newSelectedColor={...selectedColor}
    const str=index%2===0?'a'+Math.floor(index/2+1):'b'+Math.floor(index/2+1)
    newSelectedColor[str]=value;
    setSelectedColor(newSelectedColor)
  }

  const handleCheckChang = (e) => {
    setCheckValue(e.target.checked)
    if(e.target.checked){
      setSelectedColor(initialState.hx)
    };
  }

  return (
    <div>
      <Row xs={2} className="g-1">
        <Col className="d-flex justify-content-center">
          <div>{langList.colorsmbg1[lg]}</div>
        </Col>
        <Col className="d-flex justify-content-center">
          <div>{langList.colorsmbg2[lg]}</div>
        </Col>
        {Array.from({length:10},(_,index)=>(
        <Col className="d-flex justify-content-center" key={index}>
          <Form.Control
            type="color"
            id={`ColorInput2${index}`}
            value={selectedColor[
              index%2===0?'a'+Math.floor(index/2+1):'b'+Math.floor(index/2+1)
            ]}
            onChange={e=>handleChang(index,e.target.value)}
          />
        </Col>
        ))}
      </Row>
      <Row className="pt-3">
        <Form.Check
          type='checkbox'
          id='smbgcheckbox'
          label={langList.colorcell1[lg]}
          checked={checkValue}
          onChange={handleCheckChang}
        />
      </Row>
      <Row className="pt-3">
        <Button variant="outline-primary" size="sm"
          onClick={handleClick}
        >{langList.public7[lg]}</Button>
      </Row>
    </div>
  )
};

